import { beautify } from 'shared/utils/number';

export function getTitle(min: number | null, max: number | null, sign: string): string | null {
  if (min !== null && max === null) {
    return `от ${beautify(min)} ${sign}`;
  } else if (min === null && max !== null) {
    return `до ${beautify(max)} ${sign}`;
  } else if (min !== null && max !== null) {
    return `${beautify(min)} - ${beautify(max)} ${sign}`;
  }

  return null;
}
